import Link from 'next/link';
import paths from '@/paths';
import { useHideOnScroll } from './hooks/useHideOnScroll';

export const HeaderWithoutExitButton = () => {
  const hidden = useHideOnScroll();
  
  return (
    <header className={`sticky w-full top-0 left-0 px-4 bg-header backdrop-blur-md border-b border-gray-800 z-[1100] transition-transform duration-300 ${hidden ? "-translate-y-full" : "translate-y-0"}`}>
      <div className="main-container relative mx-auto h-100 min-h-20 flex flex-wrap items-center justify-start">
        <div className="w-fit lg:w-fit flex justify-start z-[2]">
          <Link href={paths.home()}>
            <img src="/static/images/logo.png" alt="FaunaExplore logo" height={42} width={37} />
          </Link>
        </div>
      </div>
    </header>
  )
};
